module.exports = __webpack_public_path__ + "img/product2-banner.b9aa6858.png";